import React from 'react';
import styles from './index.module.scss';

const SaveButton = (props) => {
  const { onClick, label = 'Save', disabled } = props;
  return (
    <button className={styles.save} onClick={onClick} disabled={disabled}>
      {label}
      {disabled && (
        <i
          className="fas fa-circle-notch fa-spin"
          style={{ width: '16px', height: '16px', fontSize: '16px' }}
        ></i>
      )}
    </button>
  );
};

export default SaveButton;
